module.exports = __webpack_public_path__ + "img/1.b4f0b6a4.jpg";